import React from "react";
import {Button, Drawer, Form, Select, Spin} from "antd";
import {GeneratorGet} from "../../../../models/generator";

const Option = Select.Option;

class ChooseBillToDrawerForm extends React.Component {
  state = {
    data: [],
    value: [],
  }

  fetchBillTo =() => {
    this.setState({ data: [], fetching: true });
    GeneratorGet(this.props.generatorID)
      .then(response => {
        const data = response.data.bill_to_rel.map(type => ({
          text: `${type.company_name} ${type.account_number}`,
          value: type.id
        }));
        this.setState({data, fetching: false })
      })
  }

  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
    //this.props.onChange(value.key);
  };

  handleDrawerSubmit = () => {
    this.props.setDrawerVisible();
    this.props.onChooseBillTo(this.state.value)
  }

  render() {
    const {visible} = this.props;
    const {fetching, data, value} = this.state;
    return (
      <Drawer title="Choose Bill To" maskClosable={false} placement="right" onClose={() => this.props.setDrawerVisible()} visible={visible} className="floating-form" destroyOnClose={true}>
        <Select labelInValue showSearch value={value} placeholder="Select Choose Bill To"
                dropdownClassName="drawer-select" notFoundContent={fetching ? <Spin size="small"/> : 'Not Found'}
                filterOption={false} onFocus={this.fetchBillTo} onSearch={this.fetchBillTo}
                onChange={this.handleChange} style={{width: "100%"}}>
          {data.map(d => (<Option key={d.value}>{d.text}</Option>))}
        </Select>
        <Button className="m-t-20" type="primary" htmlType="button" onClick={this.handleDrawerSubmit}>Choose Bill To</Button>
      </Drawer>
    )
  }
}

export const ChooseBillToDrawer = Form.create()(ChooseBillToDrawerForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/quotes/popups/ChooseBillToDrawer.jsx